import { render, staticRenderFns } from "./AdminShortenUrlsTableRow.vue?vue&type=template&id=97a35c28"
import script from "./AdminShortenUrlsTableRow.vue?vue&type=script&lang=js"
export * from "./AdminShortenUrlsTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports